"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartManager = void 0;
var lodash_1 = __importDefault(require("lodash"));
var DataContainer_1 = require("./DataContainer");
var Message_1 = require("./Message");
var ChartManager = exports.ChartManager = (function () {
    function ChartManager() {
    }
    ChartManager.getXStep = function (xValue) {
        if (xValue.match(/:/) && xValue.slice(-2) !== '00') {
            return '';
        }
        return xValue;
    };
    ChartManager.getGridLineColor = function (labelLength) {
        var colors = [];
        if (labelLength <= 32) {
            return 'rgba(0, 0, 0, 0.1)';
        }
        for (var index = 0; index <= 60 * 24; index++) {
            if (index % 60 === 0) {
                colors.push('rgba(0, 0, 0, 0.1)');
            }
            else {
                colors.push('rgba(0, 0, 0, 0)');
            }
        }
        return colors;
    };
    ChartManager.ChartJS = require('chart.js');
    ChartManager.cruiseKey = '';
    ChartManager.charts = {};
    ChartManager.init = function () {
        ChartManager.ChartJS.pluginService.register({
            beforeDraw: function (c) {
                var _a;
                if ((_a = c.config.options.chartArea) === null || _a === void 0 ? void 0 : _a.backgroundColor) {
                    var ctx = c.chart.ctx;
                    var chartArea = c.chartArea;
                    ctx.save();
                    ctx.fillStyle = c.config.options.chartArea.backgroundColor;
                    ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
                    ctx.restore();
                }
            },
        });
    };
    ChartManager.isScreenConfigGraph = function (value) {
        return value.type === 'graph';
    };
    ChartManager.createChart = function (chartId, chartDiv, targetId) {
        ChartManager.destroyChartById(chartId);
        var ctx = chartDiv;
        Message_1.Message.log(DataContainer_1.DataContainer.config.screens[targetId]);
        var screenConfig = DataContainer_1.DataContainer.config.screens[targetId].config[0];
        if (!ChartManager.isScreenConfigGraph(screenConfig))
            return;
        var graphSettings = screenConfig.graphs.map(function (graph) {
            return __assign(__assign({}, graph), { data: [] });
        });
        var graphs = [];
        var refferrers = [];
        var graphDatas = [];
        var xAxesLbale = [];
        var enableYAxiesId = [];
        var yAxes = [];
        lodash_1.default.forEach(graphSettings, function (graphSetting) {
            refferrers.push(graphSetting.dataReferrer.targetId);
            var dataId = graphSetting.dataReferrer.targetId;
            var targetData = DataContainer_1.DataContainer.getDataSetById(dataId);
            var isDisplay = DataContainer_1.DataContainer.getItemEnable(graphSetting.dataReferrer);
            if (isDisplay) {
                if (graphSetting.yAxisId && !graphSetting.yAxisID) {
                    graphSetting.yAxisID = graphSetting.yAxisId;
                }
                enableYAxiesId.push(graphSetting.yAxisID);
                if (DataContainer_1.DataContainer.isGraphApiResult(targetData)) {
                    graphDatas[Number(dataId)] = targetData;
                    var graphData = graphDatas[Number(graphSetting.dataReferrer.targetId)].chart;
                    graphSetting.data = lodash_1.default.map(graphData.graphs.graph[graphSetting.dataReferrer.dataId].value, function (elem) { return elem['#text']; });
                    xAxesLbale = lodash_1.default.map(graphData.series.value, function (elem) { return elem['#text']; });
                }
                graphs.push(graphSetting);
            }
        });
        lodash_1.default.forEach(screenConfig.yAxes, function (yAxis) {
            if (enableYAxiesId.indexOf(yAxis.id) >= 0) {
                yAxes.push(yAxis);
            }
        });
        var xAxes = screenConfig.xAxes;
        xAxes[0].labels = xAxesLbale;
        xAxes[0].ticks.autoSkip = false;
        xAxes[0].ticks.callback = ChartManager.getXStep;
        xAxes[0].gridLines.color = ChartManager.getGridLineColor(xAxes[0].labels.length);
        var scaleSettings = { xAxes: xAxes, yAxes: yAxes };
        var configurableChartOptions = screenConfig.chartOptions;
        var chartOptions = __assign(__assign({}, configurableChartOptions), { scales: scaleSettings, maintainAspectRatio: false, legend: __assign(__assign({}, configurableChartOptions.legend), { reverse: true }) });
        var chart = new ChartManager.ChartJS(ctx, {
            type: 'bar',
            data: {
                datasets: graphs,
            },
            options: chartOptions,
        });
        ChartManager.charts[chartId] = chart;
        chart.resize();
        chart.update();
    };
    ChartManager.getChartInstanceById = function (chartId) {
        try {
            return ChartManager.charts[chartId];
        }
        catch (error) {
            return {};
        }
    };
    ChartManager.updateChartById = function (chartId, targetId) {
        var screenConfig = DataContainer_1.DataContainer.config.screens[targetId].config[0];
        if (!ChartManager.isScreenConfigGraph(screenConfig))
            return;
        var graphSettings = screenConfig.graphs;
        var graphDatas = {};
        var xAxesLabel = [];
        var index = 0;
        graphSettings.forEach(function (graphSetting) {
            var data = [];
            var dataId = graphSetting.dataReferrer.targetId;
            var isDisplayable = DataContainer_1.DataContainer.getItemEnable(graphSetting.dataReferrer);
            if (!isDisplayable)
                return;
            var dataSet = DataContainer_1.DataContainer.getDataSetById(dataId);
            if (DataContainer_1.DataContainer.isGraphApiResult(dataSet)) {
                graphDatas[dataId] = dataSet;
                var graphData = graphDatas[dataId].chart;
                if (graphData) {
                    data = lodash_1.default.map(graphData.graphs.graph[graphSetting.dataReferrer.dataId].value, function (eachValue) { return eachValue['#text']; });
                    if (!xAxesLabel.length) {
                        xAxesLabel = lodash_1.default.map(graphData.series.value, function (eachValue) { return eachValue['#text']; });
                        ChartManager.charts[chartId].options.scales.xAxes[0].labels = xAxesLabel;
                    }
                }
            }
            ChartManager.charts[chartId].data.datasets[index].data = data;
            index++;
        });
        ChartManager.charts[chartId].update();
    };
    ChartManager.destroyChartById = function (chartId) {
        if (ChartManager.charts[chartId]) {
            ChartManager.charts[chartId].destroy();
            ChartManager.charts[chartId] = null;
        }
    };
    return ChartManager;
}());
